import { render, staticRenderFns } from "./IconIdentificationOutline.vue?vue&type=template&id=601db072"
import script from "./IconIdentificationOutline.vue?vue&type=script&lang=js"
export * from "./IconIdentificationOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports